import React from 'react';
import PropTypes from 'prop-types';

import format from 'date-fns/format';

import {
    StyledTourCardDetailsText,
} from './StyledComponents';

const propTypes = {
    tour: PropTypes.shape({
        name: PropTypes.string.isRequired,
        createdDate: PropTypes.string.isRequired,
        creatorName: PropTypes.string.isRequired,
        imageSrc: PropTypes.string,
        state: PropTypes.oneOf(['active', 'inactive', 'empty']),
    }).isRequired,
    size: PropTypes.oneOf(['sm', 'md']),
};

const defaultProps = {
    size: 'sm',
};

const TourCardDetails = ({
    tour,
    size,
}) => (
    <div>
        <StyledTourCardDetailsText as="div" paddingBottom="xs" fontType="label">
            {tour.name || 'No tour name'}
        </StyledTourCardDetailsText>
        <StyledTourCardDetailsText as="div" fontType={size === 'md' ? 'body' : 'smallbody'}>
            {`Created ${format(new Date(tour.createdDate), 'MM/DD/YYYY')}`}
        </StyledTourCardDetailsText>
        {false && (
            <StyledTourCardDetailsText as="div" paddingBottom="xs" fontType={size === 'md' ? 'body' : 'smallbody'}>
                {`By ${tour.creatorName || 'unknown'}`}
            </StyledTourCardDetailsText>
        )}
    </div>
);

TourCardDetails.propTypes = propTypes;
TourCardDetails.defaultProps = defaultProps;

export default TourCardDetails;
